<div class="pp-bulk" *ngIf="selectedCount > 0" role="toolbar" aria-label="Bulk actions">
  <span class="pp-bulk__count">{{ selectedCount }} selected</span>
  <button
    *ngIf="showStatus"
    type="button"
    class="pp-btn"
    [disabled]="busy"
    (click)="changeStatus.emit($event)">
    <i class="pi pi-flag"></i>
    Change status
    <i class="pi pi-angle-down"></i>
  </button>
  <button
    *ngIf="showPriority"
    type="button"
    class="pp-btn"
    [disabled]="busy"
    (click)="changePriority.emit($event)">
    <i class="pi pi-sort-amount-up-alt"></i>
    Change priority
    <i class="pi pi-angle-down"></i>
  </button>
  <button
    *ngIf="showArchive && archived !== true"
    type="button"
    class="pp-btn"
    [disabled]="busy"
    (click)="archive.emit(true)">
    <i class="pi pi-inbox"></i>
    Archive
  </button>
  <button
    *ngIf="showArchive && archived !== false"
    type="button"
    class="pp-btn"
    [disabled]="busy"
    (click)="archive.emit(false)">
    <i class="pi pi-replay"></i>
    Unarchive
  </button>
  <button
    *ngIf="showDelete"
    type="button"
    class="pp-btn pp-btn--danger"
    [disabled]="busy"
    (click)="deleteSelected.emit()">
    <i class="pi pi-trash"></i>
    Delete
  </button>
  <button
    *ngIf="showExport"
    type="button"
    class="pp-btn"
    [disabled]="busy"
    (click)="exportSelected.emit()"
    title="Export selected rows">
    <i class="pi pi-download"></i>
    Export selected
  </button>
  <i *ngIf="busy" class="pi pi-spin pi-spinner pp-bulk__spinner" aria-label="Working"></i>
  <button type="button" class="pp-btn--ghost" [disabled]="busy" (click)="clear.emit()">Clear</button>
</div>
